import { EventMeta } from '../../../interfaces/meta.interface';

const softDelete: EventMeta = {
    title: 'Soft Delete',
    default: {
        description: 'Soft Delete',
        longDescription:
            'A message was permanently deleted or deleted from the Deleted Items folder. Soft-deleted items are moved to the Recoverable Items folder.',
        severity: 'info',
    },
};

export default softDelete;
